import { FC, useEffect } from 'react';
import { ThreeDPoint, ThreeDPointProps } from '../3dModels/ThreeDPoint';
import { MetricKeyEnum, useLayerStore } from '../LayerControls/layerStore';
import { useHighlighter } from '../ui/useHighlighter';

interface CenterOfMassProps extends ThreeDPointProps {
  layerKey: MetricKeyEnum.CenterOfMass | MetricKeyEnum.CenterOfMassAboveHips;
}

export const CenterOfMass: FC<CenterOfMassProps> = ({ layerKey, ...props }) => {
  useHighlighter({ layerKey });
  const { addLayerState, isLayerVisible } = useLayerStore();

  useEffect(() => {
    addLayerState(layerKey, {
      key: layerKey,
      visible: false,
    });
  }, [addLayerState, layerKey]);

  const showLayer = isLayerVisible(layerKey);

  return (
    <group name={layerKey} visible={showLayer}>
      <ThreeDPoint {...props} />
    </group>
  );
};
